import * as cf from './common';
import * as base from './base';
import { rf_title_by_type } from 'console/tabs/legacy/rf/rf-utils';
import { LoadDataType } from '../load-types';
class BaseRFGraph extends base.GraphSource {
    serial;
    _device;
    constructor(device, { serial, color }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this._device = device;
        this.serial = serial;
        this._color = color;
    }
    spec() {
        return this._device?.rf_status()?.[this.serial];
    }
    serialize_params() {
        return { serial: this.serial, color: this._color };
    }
    is_same(other) {
        // @ts-ignore
        return super.is_same(...arguments) && this.serial === other.serial;
    }
    title() {
        return (this.spec()?.name ?? rf_title_by_type(this.spec()?.type, this.spec()?.slot));
    }
    color() {
        if (this._color)
            return this._color;
        return this._device.rf_color(this.serial);
    }
    gap_width() {
        if (this.spec()?.version === 1246) {
            return 240 * 60;
        }
        else {
            return 30 * 60;
        }
    }
    data_source_key() {
        return LoadDataType.rf;
    }
    getter(props) { }
    extract_data(raw_data) {
        return (raw_data?.[this.serial] ?? []).map(([time, data]) => [
            time,
            this.getter(data),
        ]);
    }
    normalize_data(data) {
        return cf.time_mul_1k(cf.add_gaps(cf.normalize_time(data, 0), this.gap_width()));
    }
}
export class RFTemperatureGraphSource extends BaseRFGraph {
    class_name() {
        return 'RFTemperatureGraphSource';
    }
    yaxis_key() {
        return 'temperature';
    }
    getter(rf_props) {
        return rf_props?.temp;
    }
}
export class RFBatteryGraph extends BaseRFGraph {
    class_name() {
        return 'RFBatteryGraph';
    }
    yaxis_key() {
        return 'voltage';
    }
    getter(rf_props) {
        return rf_props?.bat_v;
    }
    title() {
        //@ts-ignore
        return `Напряжение ${super.title(...arguments)}`;
    }
}
export class RFSignalGraph extends BaseRFGraph {
    class_name() {
        return 'RFSignalGraph';
    }
    yaxis_key() {
        return 'dbm';
    }
    getter(rf_props) {
        return rf_props?.dbm;
    }
    title() {
        //@ts-ignore
        return `Сигнал ${super.title(...arguments)}`;
    }
}
export class RFHumidityGraph extends BaseRFGraph {
    class_name() {
        return 'RFHumidityGraph';
    }
    yaxis_key() {
        return 'percent';
    }
    getter(rf_props) {
        return rf_props?.hum;
    }
}
